<template>
  <div
    class="d-flex align-items-center border mb-8"
    style="border-bottom: 1px solid #5c4a4a17"
  >
    <v-container fluid class="p-0">
      <div
        class="d-flex align-items-center border-bottom p-2"
        style="font-size: 11px"
      >
        PERFORMANCE
      </div>
      <div
        class="row d-flex align-items-center justify-content-end mt-4 mr-3"
        style="height: 40px"
      >
        <!-- <div class="col-12 d-flex flex-column align-items-baseline"> -->
        <!-- <ol
            class="breadcrumb float-sm-right"
            style="
              position: absolute;
              right: 0;
              width: 43%;
              display: flex;
              align-items: center;
              justify-content: end;
            "
          > -->
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value="datePicker"
          :max="maxDate"
          transition="scale-transition"
          offset-y
          max-width="500px !important"
          max-height="500px !important"
          style="max-height: max-content !important"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="datePickerRangeText"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              dense
              full-width
              v-bind="attrs"
              v-on="on"
              :disabled="loading"
              :loading="loading"
              :rules="requiredRule"
              required
              style="right: 0; max-width: 250px !important"
            ></v-text-field>
          </template>
          <v-container fluid>
            <v-row
              class="v-menu--container__width"
              justify="space-around"
              align-content="center"
            >
              <v-col cols="7">
                <v-row>
                  <v-col cols="7">
                    <v-autocomplete
                      v-model="selectedTimezone"
                      :items="timezones"
                      :rules="requiredRule"
                      :disabled="loading"
                      :loading="loading"
                      class="mb-2"
                      auto-select-first
                      dense
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="5" class="px-0">
                    <v-autocomplete
                      v-model="selectedDateTrunc"
                      :items="[
                        {
                          text: 'Day',
                          value: 'day',
                        },
                        {
                          text: 'Month',
                          value: 'month',
                        },
                        {
                          text: 'Year',
                          value: 'year',
                        },
                      ]"
                      :rules="requiredRule"
                      :disabled="loading"
                      :loading="loading"
                      class="px-2"
                      auto-select-first
                      dense
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-date-picker
                  v-model="datePicker"
                  range
                  no-title
                  scrollable
                  :min="minDate"
                  :max="maxDate"
                  :disabled="loading"
                  :loading="loading"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(datePicker)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-col>
              <v-col cols="3" class="py-0">
                <v-chip-group
                  v-model="selectedDateRangePreset"
                  column
                  class="v-chip-group--width"
                >
                  <v-chip
                    v-for="tag in [
                      'Today',
                      'Yesterday',
                      'Last 7 days',
                      'This month',
                      'Last month',
                      'Last 30 days',
                      'Last 3 months',
                      // 'Last 6 months',
                    ]"
                    :key="tag"
                    :value="tag"
                    outlined
                  >
                    {{ tag }}
                  </v-chip>
                </v-chip-group></v-col
              >
            </v-row>
          </v-container>
        </v-menu>
        <v-autocomplete
          v-model="selectedHeaderItems"
          :items="dynamicHeaderItems"
          :return-object="true"
          :loading="loading"
          :disabled="loading"
          multiple
          outlined
          dense
          class="pa-2"
          style="max-width: fit-content; margin-left: 14px"
        >
          <template v-slot:prepend-item>
            <v-checkbox
              :input-value="areAllHeadersSelected"
              label="Select All"
              @change="toggleHeadersSelectAll"
              color="primary"
              class="pl-4"
            >
            </v-checkbox>
            <v-divider class="m-0 mb-4"></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
            <p
              v-if="index === 0 && selectedHeaderItems.length < 3"
              class="text-transform--ellipsis mb-0 pl-1"
            >
              {{ item.text }}
            </p>
            <span
              v-if="index === 1 && selectedHeaderItems.length !== 3"
              class="m-0 p-0 grey--text text-caption v-chip__width"
            >
              (+
              {{ selectedHeaderItems.length - 1 }})
            </span>
            <p
              v-else-if="index === 0 && selectedHeaderItems.length === 3"
              class="mb-0"
            >
              All
            </p>
          </template>
        </v-autocomplete>
        <v-btn
          color="primary"
          class="ml-3 mb-8"
          style="width: fit-content"
          :loading="loading"
          :disabled="loading"
          @click="getData"
          >Get Data</v-btn
        >
        <!-- </ol> -->
        <!-- </div> -->
      </div>
      <v-row>
        <v-col cols="6">
          <v-card>
            <!-- <v-card-title>Top Client Welcome</v-card-title> -->
            <v-data-table
              v-if="isModerRole"
              :headers="clientTableHeaders"
              :items="client.welcome.items"
              :loading="loading"
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-icon color="primary" class="mr-3 pr-3 border-right">
                    mdi-table
                  </v-icon>
                  <!-- <v-divider
                                        class="mx-2"
                                        dark
                                        vertical
                                    ></v-divider> -->
                  <v-toolbar-title
                    >Top Clients By Sent Welcome Messages</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    color="primary"
                    :loading="isExportFileLoading"
                    :disabled="isExportFileLoading"
                    @click="exportData('clientWelcome', client.welcome.items)"
                  >
                    <v-icon>mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.clicked`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.clicked) }}
                </p>
              </template>
              <template v-slot:[`item.delivered`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.delivered) }}
                </p>
              </template>
              <template v-slot:[`item.sent`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.sent) }}
                </p>
              </template>
            </v-data-table>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card>
            <v-data-table
              v-if="isModerRole"
              :headers="clientTableHeaders"
              :items="client.recurring.items"
              :loading="loading"
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-icon color="primary" class="mr-3 pr-3 border-right">
                    mdi-table
                  </v-icon>
                  <!-- <v-divider
                                        class="mx-2"
                                        dark
                                        vertical
                                    ></v-divider> -->
                  <v-toolbar-title
                    >Top Clients By Sent Recurring Messages</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    color="primary"
                    :loading="isExportFileLoading"
                    :disabled="isExportFileLoading"
                    @click="
                      exportData('clientRecurring', client.recurring.items)
                    "
                  >
                    <v-icon>mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.clicked`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.clicked) }}
                </p>
              </template>
              <template v-slot:[`item.delivered`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.delivered) }}
                </p>
              </template>
              <template v-slot:[`item.sent`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.sent) }}
                </p>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-data-table
              :headers="domainTableHeaders"
              :items="domain.welcome.items"
              :loading="loading"
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-icon color="primary" class="mr-3 pr-3 border-right">
                    mdi-table
                  </v-icon>
                  <!-- <v-divider
                                        class="mx-2"
                                        dark
                                        vertical
                                    ></v-divider> -->
                  <v-toolbar-title
                    >Top Domains By Sent Welcome Messages</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    color="primary"
                    :loading="isExportFileLoading"
                    :disabled="isExportFileLoading"
                    @click="exportData('domainWelcome', domain.welcome.items)"
                  >
                    <v-icon>mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.website_id`]="{ item }">
                <p class="m-0">
                  {{ getWebsiteIdField(item.website_id) }}
                </p>
              </template>
              <template v-slot:[`item.clicked`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.clicked) }}
                </p>
              </template>
              <template v-slot:[`item.delivered`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.delivered) }}
                </p>
              </template>
              <template v-slot:[`item.sent`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.sent) }}
                </p>
              </template>
            </v-data-table>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card>
            <v-data-table
              :headers="domainTableHeaders"
              :items="domain.recurring.items"
              :loading="loading"
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-icon color="primary" class="mr-3 pr-3 border-right">
                    mdi-table
                  </v-icon>
                  <!-- <v-divider
                                        class="mx-2"
                                        dark
                                        vertical
                                    ></v-divider> -->
                  <v-toolbar-title
                    >Top Domains By Sent Recurring Messages</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    color="primary"
                    :loading="isExportFileLoading"
                    :disabled="isExportFileLoading"
                    @click="
                      exportData('domainRecurring', domain.recurring.items)
                    "
                  >
                    <v-icon>mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.website_id`]="{ item }">
                <p class="m-0">
                  {{ getWebsiteIdField(item.website_id) }}
                </p>
              </template>
              <template v-slot:[`item.clicked`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.clicked) }}
                </p>
              </template>
              <template v-slot:[`item.delivered`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.delivered) }}
                </p>
              </template>
              <template v-slot:[`item.sent`]="{ item }">
                <p class="m-0">
                  {{ formatNumberWithCommas(item.sent) }}
                </p>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Success Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        :message="successMessage"
      />
    </transition>

    <!-- Failure Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        :message="failureMessage"
      />
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Statistics from "../../apis/Statistics";
import common from "../../mixins/common";
import { serializeObjToQueryParams } from "../../utils";
import { EchoService } from "../../services/EchoService";

const momentTimezone = require("moment-timezone");

export default {
  name: "ClientPerformance",
  mixins: [common],
  components: {
    SuccessSnackbar,
    FailureSnackbar,
  },
  data() {
    return {
      requiredRule: [
        (v) => (Array.isArray(v) ? !!v.length : !!v || "Field is required."),
      ],

      menu: false,
      selectedDateTrunc: "day",
      selectedGroupBy: [],

      client: {
        welcome: {
          items: [],
          options: {},
          total: 0,
        },
        recurring: {
          items: [],
          options: {},
          total: 0,
        },
      },
      domain: {
        welcome: {
          items: [],
          options: {},
          total: 0,
        },
        recurring: {
          items: [],
          options: {},
          total: 0,
        },
      },

      topRecurringDrip: null,
      topWelcomeDomains: null,
      topWelcomeDrip: null,
      topWelcomeDomain: null,

      selectedHeaderItems: [
        {
          text: "Sent",
          value: "sent",
          align: "right",
          class: "table-header--color",
        },
      ],
      dynamicHeaderItems: [
        {
          text: "Sent",
          value: "sent",
          sortable: true,
          align: "right",
          class: "table-header--color",
        },
        {
          text: "Deliveries",
          value: "delivered",
          sortable: true,
          width: "105px",
          align: "right",
          class: "table-header--color",
        },
        {
          text: "Clicks",
          value: "clicked",
          sortable: true,
          width: "85px",
          align: "right",
          class: "table-header--color",
        },
      ],

      datePicker: [
        moment().subtract(1, "day").startOf("day").format("YYYY-MM-DD"),
        moment().subtract(1, "day").startOf("day").format("YYYY-MM-DD"),
      ],
      selectedDateRangePreset: null,
      minDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),
      selectedTimezone: momentTimezone.tz.guess(),
      timezones: momentTimezone.tz.names(),

      success: false,
      successMessage: "",
      failure: false,
      failureMessage: "",

      loading: false,
      isExportFileLoading: false,
    };
  },
  computed: {
    ...mapState({
      domains: (state) => state.domain.domains,
      userId: (state) => state.user.user?.id,
    }),
    ...mapGetters(["roles", "clientUid", "selectedDomainWebsiteId"]),
    isModerRole() {
      return this.roles.includes("moder");
    },
    datePickerRangeText() {
      return this.datePicker.join(" ~ ");
    },
    domainTableHeaders() {
      return [
        {
          text: "Domain ID",
          value: "website_id",
          sortable: true,
          divider: true,
          align: "left",
          class: "table-header--color",
        },
        ...this.selectedHeaderItems,
      ];
    },
    clientTableHeaders() {
      return [
        {
          text: "Client",
          value: "client",
          sortable: true,
          divider: true,
          align: "left",
          class: "table-header--color",
        },
        {
          text: "Drip ID",
          value: "drip_id",
          sortable: true,
          divider: true,
          align: "left",
          width: "90px",
          class: "table-header--color",
        },
        ...this.selectedHeaderItems,
      ];
    },
    areAllHeadersSelected() {
      return this.selectedHeaderItems.length === this.dynamicHeaderItems.length;
    },
  },
  created() {
    const echoInstance = new EchoService();

    echoInstance.listen("files", ".file.status-updated", (response) => {
      if (response?.status === "ready" || response?.status === "failed") {
        this.isExportFileLoading = false;
      }

      if (response?.status === "failed") {
        this.failureText = "Failed to generate file.";
        this.failure = true;
      }

      if (response?.status === "ready" && this.userId === response?.userId) {
        try {
          this.openTab(response.link);
        } catch (e) {
          throw new Error(e?.message || e);
        }
      }
    });
  },
  async mounted() {
    this.loading = true;
    if (!this.isModerRole) {
      await this.show();
    }
    await this.fetchAllStatistics();
  },
  methods: {
    ...mapActions(["show"]),
    getResponseColumnSettings() {
      return {
        map: { timestamp: "date" },
        expand: ["deactivated", "full_unsubscribed", "avg_patient_days"],
        include: ["client"],
        //select: ["type"],
      };
    },
    getWebsiteIdField(websiteId) {
      if (!this.isModerRole) {
        return this.selectedDomainWebsiteId(websiteId) !== undefined
          ? this.selectedDomainWebsiteId(websiteId)["url"]
          : websiteId;
      } else {
        return websiteId;
      }
    },
    getResponseSorting(data) {
      console.log("🚀 ~ getResponseSorting ~ data:", data);
      if (!data.items.length) {
        this.failureMessage = "Unable to sort due to invalid data.";
        this.failure = true;

        throw new Error("Unable to sort due to invalid data.");
      }

      let { sortBy, sortDesc } = data.options;
      let keysMapping = {
        date: "timestamp",
        client: "client_id",
      };

      return sortBy.length && sortDesc.length
        ? new Array({
            [keysMapping[sortBy[0]] || sortBy[0]]: sortDesc[0] ? "DESC" : "ASC",
          })
        : [];
    },
    async preparePayload(data) {
      // const types = this.selectedGroupBy.filter(
      //     (el) => el === "welcome" || el === "recurring"
      // );
      const columns = await this.getResponseColumnSettings();
      //const orders = data.items.length
      //? await this.getResponseSorting(data)
      //: [];
      let params = {
        paginate: true,
        pageLength: 5,
        //data.options.itemsPerPage,
        page: data.options.page,
      };

      // if (
      //     types.length &&
      //     !this.selectedGroupBy.some((el) => el === "type")
      // ) {
      //     this.selectedGroupBy.push("type");
      // } else if (!types.length) {
      //     this.selectedGroupBy = this.selectedGroupBy.filter(
      //         (el) => el !== "type"
      //     );
      // }

      const payload = {
        timezone: this.selectedTimezone,
        date_trunc: this.selectedDateTrunc,
        columns: columns,
        filters: {
          date_start: moment(this.datePicker[0]).format("YYYY-MM-DD"),
          date_end: moment(this.datePicker[1]).format("YYYY-MM-DD"),
          website_id: this.areAllDomainsSelected ? [] : this.selectedDomain,
          //type: types,
        },
        //orders: orders,
        groups: ["timestamp"],
      };

      if (this.isModerRole) {
        payload.filters.client_id = [];
      } else {
        payload.filters.client_id = new Array(this.clientUid);
      }
      params = await serializeObjToQueryParams(params);

      return {
        payload,
        params,
      };
    },
    async getTopRecurringDripStatistics(file = false) {
      let { payload, params } = await this.preparePayload(
        this.client.recurring
      );
      params = params.substring(1);

      return Statistics.getTopRecurringDripStatistics({
        payload,
        params,
        file,
      });
    },
    async getTopRecurringDomainsStatistics(file = false) {
      let { payload, params } = await this.preparePayload(
        this.domain.recurring
      );
      params = params.substring(1);

      return Statistics.getTopRecurringDomainsStatistics({
        payload,
        params,
        file,
      });
    },
    async getTopWelcomeDripStatistics(file = false) {
      let { payload, params } = await this.preparePayload(this.client.welcome);
      params = params.substring(1);

      return Statistics.getTopWelcomeDripStatistics({
        payload,
        params,
        file,
      });
    },
    async getTopWelcomeDomainsStatistics(file = false) {
      let { payload, params } = await this.preparePayload(this.domain.welcome);
      params = params.substring(1);

      return Statistics.getTopWelcomeDomainsStatistics({
        payload,
        params,
        file,
      });
    },
    async fetchAllStatistics() {
      let requestTypeMapping = {};

      this.loading = true;

      const requests = [
        this.getTopRecurringDomainsStatistics(),
        this.getTopWelcomeDomainsStatistics(),
      ];

      if (this.isModerRole) {
        requests.push(
          this.getTopRecurringDripStatistics(),
          this.getTopWelcomeDripStatistics()
        );
      }

      const results = await Promise.allSettled(requests);

      results.forEach((result, index) => {
        console.log("🚀 ~ results.forEach ~ result:", result);
        if (result.status === "fulfilled") {
          let typeEntity =
            result.value.config.url &&
            result.value.config.url.includes("Domains")
              ? "domain"
              : "client";
          let dripType =
            result.value.config.url &&
            result.value.config.url.includes("Recurring")
              ? "recurring"
              : "welcome";

          console.log(
            "🚀 ~ results.forEach ~ result:",
            result,
            typeEntity,
            dripType
          );

          this[typeEntity][dripType].items = result.value.data.data;
          this[typeEntity][dripType].total = result.value.data.meta.total;
          // switch (result.value.config) {
          //     case "result":
          //         this.client.recurring.items =
          //             result.value.data.data;
          //         this.client.recurring.total =
          //             result.value.data.meta.total;
          //         break;
          //     case 2:
          //         this.client.welcome.items = result.value.data.data;
          //         this.client.welcome.total =
          //             result.value.data.meta.total;
          //         break;
          //     case 1:
          //         this.domain.recurring.items =
          //             result.value.data.data;
          //         this.domain.recurring.total =
          //             result.value.data.meta.total;
          //         break;
          //     case :
          //         this.domain.welcome.items = result.value.data.data;
          //         this.domain.welcome.total =
          //             result.value.data.meta.total;
          //         break;
          // }
        } else {
          console.error(`Request ${index + 1} failed:`, result.reason);
          this.failureMessage = `Failed to load some statistics. Please try again.`;
          this.failure = true;
        }
      });

      this.loading = false;
    },
    setDateRangePreset(preset) {
      const today = moment();
      let start = null;
      let end = null;

      switch (preset) {
        case "Today":
          start = today.clone().startOf("day");
          end = today;
          break;

        case "Yesterday":
          start = today.clone().subtract(1, "day").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 7 days":
          start = today.clone().subtract(7, "days").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "This month":
          start = today.clone().startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last month":
          start = today.clone().startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 30 days":
          start = today.clone().subtract(30, "days").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 3 months":
          start = today.clone().subtract(3, "months").startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 6 months":
          start = today.clone().subtract(6, "months").startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        default:
          console.error("Unknown preset:", preset);
          return;
      }

      this.datePicker = [start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")];
    },
    formatNumberWithCommas(number) {
      return number.toLocaleString();
    },
    getData() {
      this.fetchAllStatistics();
    },
    async exportData(type, items) {
      console.log("🚀 ~ exportData ~ type, items:", type, items);

      this.isExportFileLoading = true;

      try {
        if (!items.length) {
          this.failureMessage =
            "No data available. Please ensure you have the required data before attempting to retrieve the file.";
          this.failure = true;
          this.isExportFileLoading = false;
          throw new Error(
            "No data available. Please ensure you have the required data before attempting to retrieve the file."
          );
        }

        const requestMapping = {
          clientWelcome: "getTopWelcomeDripStatistics",
          clientRecurring: "getTopRecurringDripStatistics",
          domainWelcome: "getTopWelcomeDomainsStatistics",
          domainRecurring: "getTopRecurringDomainsStatistics",
        };

        if (!Object.keys(requestMapping).includes(type)) {
          this.failureMessage = "Provided invalid type.";
          this.failure = true;
          throw new Error("Provided invalid type.");
        }

        await this[requestMapping[type]](true);
      } catch (e) {
          this.failureMessage = e;
          this.failure = true;
          console.error(e);
      } finally {
        this.isExportFileLoading = false;
      }
    },
    toggleHeadersSelectAll(isChecked) {
      if (isChecked) {
        this.selectedHeaderItems = this.dynamicHeaderItems;
      } else {
        this.selectedHeaderItems = [];
      }
    },
  },
  watch: {
    selectedDateRangePreset(preset) {
      if (preset) {
        this.setDateRangePreset(preset);
      }
    },
  },
};
</script>
